module.exports = __webpack_public_path__ + "static/media/TEL.4745f636.png";